// angular.module('HeroPRO')
// 	.directive('filterOption',


import './filterOptions.scss';

export default function FilterOptionDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/pipeline/filter/filterOptions/filterOptionsTemplate.html',
        scope: {
            label: '=',
            value: '=',
            isStatus: '=',
        },
        controllerAs: 'filterOptn',
    };
}



// WEBPACK FOOTER //
// ./src/app/pipeline/filter/filterOptions/filterOptionsDirective.js